import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { TrendingUp } from "lucide-react";

interface ForecastData {
    predicted_revenue: number;
    period: string;
    confidence: string;
}

interface RevenueForecastBlockProps {
    forecast: ForecastData;
}

const RevenueForecastBlock: React.FC<RevenueForecastBlockProps> = ({ forecast }) => {
    return (
        <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">Revenue, Last 28 Days</CardTitle>
                <TrendingUp className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
                <div className="font-display text-2xl font-bold">₦{forecast?.predicted_revenue?.toLocaleString() || 0}</div>
                {/* The API's figure is what was paid out over the last 28 days, not a forecast. */}
                <p className="text-xs text-muted-foreground">
                    Paid out to you in the last 28 days
                </p>
            </CardContent>
        </Card>
    );
};

export default RevenueForecastBlock;
